/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Empty({
  children,
  viewPath = "/App/ChooseUser/Users/Empty"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Empty.Text"
  data-view-path={viewPath}
 className="views-text"
>
There are no results
</span>
{children}
</React.Fragment>)
}